import { stripAccentsLower } from '@/utils/textEncoding';

/** Planos/categorias fixos do motor Carolino (backoffice + convenção de dados). */
export const CAROLINO_CATEGORIA_OPTIONS = [
  'Básico',
  'Essencial',
  'Clássico',
  'Especial',
] as const;

export type CarolinoCategoria = (typeof CAROLINO_CATEGORIA_OPTIONS)[number];

/** Normaliza variações sem acento / capitalização para as 4 categorias oficiais. */
export function normalizeCarolinoCategoria(value: string): string {
  const key = stripAccentsLower(value);
  const map: Record<string, CarolinoCategoria> = {
    basico: 'Básico',
    essencial: 'Essencial',
    classico: 'Clássico',
    especial: 'Especial',
  };
  return map[key] ?? value.trim();
}

export function isCarolinoCategoria(value: string): value is CarolinoCategoria {
  const normalized = normalizeCarolinoCategoria(value);
  return (CAROLINO_CATEGORIA_OPTIONS as readonly string[]).includes(normalized);
}
